import { apiClient } from "../../utils/apiClient";
import { PersonaVetada } from "../../types/personaVetada";

// Obtener todas las personas vetadas
export const fetchPersonasVetadas = async (): Promise<PersonaVetada[]> => {
  const response = await apiClient.get(`/blackList`);
  return response.data;
};

// Crear o actualizar una persona vetada
export const upsertPersonaVetada = async (
  persona: PersonaVetada
): Promise<PersonaVetada> => {
  const response = await apiClient.post(`/blackList/upsertBlackList`, persona);
  return response.data;
};

// Obtener una persona vetada por cédula (para validación)
export const getPersonaVetadaByCedula = async ( cedula: string): Promise<PersonaVetada | null> => {
  console.log("Buscando persona vetada por cédula:", cedula);
  try {
    const response = await apiClient.get(`/blackList/vetado/${cedula}`);

    console.log("Respuesta completa del backend:", response.data);

    // Verifica si es un array
    if (Array.isArray(response.data)) {
      // Si es un array, toma el primer elemento
      if (response.data.length === 0) {
        return null;
      }
      console.log("Primer elemento del array:", response.data[0]);
      return response.data[0];
    }
    // Si no es array, verifica si es objeto
    else if (response.data && typeof response.data === "object") {
      // Verifica si tiene veto_id (puede ser objeto vacío)
      if (response.data.veto_id !== undefined) {
        return response.data;
      }
      return null;
    }

    return null;
  } catch (error: any) {
    // Si es error 404, retorna null (no encontrado)
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error;
  }
};
